module.exports = __webpack_public_path__ + "img/button-sub.eefd49e9.png";